import {PointOfInterest} from "../interface/PointOfInterest";

export const getPointsOfInterests = (itineraryId: string): PointOfInterest[] => {
    switch (itineraryId) {
        case 'tour-de-treme':
            return [
                {
                    title: 'techniConcept Sàrl',
                    geopoint: {
                        lat: 46.609322,
                        lng: 7.065120
                    }
                },
                {
                    title: 'techniConcept Sàrl',
                    geopoint: {
                        lat: 46.609051,
                        lng: 7.065500
                    }
                }
            ]
        case 'blonay':
            return [
                {
                    title: 'Boulangerie chez Yann',
                    geopoint: {
                        lat: 46.468340,
                        lng: 6.893725
                    }
                },
                {
                    title: 'Trains à Vapeur Blonay-Chamby',
                    geopoint: {
                        lat: 46.465114,
                        lng: 6.896221
                    }
                }
            ]
        default:
            return []
    }
}
